var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8438 9L16.5312 4.3125C17.1406 3.75 17.1406 2.8125 16.5312 2.25L15.5 1.21875C14.9375 0.609375 14 0.609375 13.4375 1.21875L8.75 5.90625L4.01562 1.21875C3.45312 0.609375 2.51562 0.609375 1.95312 1.21875L0.921875 2.25C0.3125 2.8125 0.3125 3.75 0.921875 4.3125L5.60938 9L0.921875 13.7344C0.3125 14.2969 0.3125 15.2344 0.921875 15.7969L1.95312 16.8281C2.51562 17.4375 3.45312 17.4375 4.01562 16.8281L8.75 12.1406L13.4375 16.8281C14 17.4375 14.9375 17.4375 15.5 16.8281L16.5312 15.7969C17.1406 15.2344 17.1406 14.2969 16.5312 13.7344L11.8438 9Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.33bdde6cc5fd6c920cba4d3a04134887.svg";
export { ForwardRef as ReactComponent };